import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '@salesforce/design-system-react/components/icon';

export interface ICheckboxProps {
    name: string;
    checked?: boolean;
    onChange: (checked: boolean) => void;
}

export function CheckboxInput({name, checked = false, onChange} : ICheckboxProps) {
    const {t} = useTranslation();

    return (
        <div className="slds-form-element">
            <div className="slds-form-element__control">
                <div className="slds-checkbox">
                    <input 
                        type="checkbox" 
                        id={`checkbox-${name}`}
                        checked={checked} 
                        onChange={(evt) => {
                            onChange(evt.currentTarget.checked);
                        }}
                    />
                    <label className="slds-checkbox__label" htmlFor={`checkbox-${name}`}>
                        <span className="slds-checkbox_faux"></span>
                        <span className="slds-form-element__label">
                            {t("task_input_" + name)}
                            {name === "Prefer_Push_Upgrade" && (
                                <span className="slds-m-left_xx-small">
                                    <span 
                                        className="slds-button slds-button_icon slds-button_icon-container slds-m-left_xx-small"
                                        title={t("prefer_push_upgrade_info")}
                                    >
                                        <Icon 
                                            category="utility" 
                                            name="info" 
                                            size="x-small" 
                                            className="slds-icon-text-default"
                                        />
                                    </span>
                                </span>
                            )}
                        </span>
                    </label>
                </div>
            </div>
        </div>
    );
}
